// extracted by mini-css-extract-plugin
export default {"editUser":"EditUser_editUser__TvgDQ","error":"EditUser_error__Aj-Ui","colorInput":"EditUser_colorInput__jnQpA"};